import {Controller} from "@hotwired/stimulus";

// Converts any swap elements to the opposite state.
export default class extends Controller {
  static targets = ["swap", "formField"];
  static values = {forceActive: Boolean};

  connect() {
    // If this is swapping a form field, and the form field has a value, swap the elements.
    // If the form field is forced active, then there is something related to this field that the user needs to see.
    if ((this.formFieldTarget && this.formFieldTarget.value) || this.forceActiveValue) {
      this.swap();
    }
  }

  swap() {
    this.swapTargets.forEach((element) => {
      element.classList.toggle("d-none");
    });
  }
}
